import cartFunctions from './cartFunctions';

export default {
  functions: [...cartFunctions],
};
